export default __webpack_public_path__ + "static/media/overcast-icon.951fcb1b.png";